// src/components/platform/ui/Badges.jsx
export function ScopeBadge({ scope }) {
  if (!scope) return null;

  const cls =
    scope === "aoi"
      ? "bg-orange-500/15 text-orange-300"
      : "bg-slate-500/15 text-slate-300";

  return (
    <span className={`px-2 py-0.5 rounded text-[11px] font-medium ${cls}`}>
      {scope.toUpperCase()}
    </span>
  );
}

export function StatusBadge({ status }) {
  if (!status) return null;

  const cls =
    status === "active"
      ? "bg-teal-500/15 text-teal-300"
      : status === "disabled"
      ? "bg-red-500/15 text-red-300"
      : "bg-yellow-500/15 text-yellow-300";

  return (
    <span className={`px-2 py-0.5 rounded text-[11px] font-medium ${cls}`}>
      {status}
    </span>
  );
}